import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Observable, from } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';

export interface ISignInCredentials {
  email: string;
  password: string;
}

export interface ICreateCredentials {
  email: string;
  password: string;
  displayName: string;
}

export interface IPasswordReset {
  code: string;
  newPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  baseUrl: any
  constructor(private afAuth: AngularFireAuth, private http: HttpClient) {

      // this.baseUrl = 'http://207.180.235.229/esalesapi/'
      //this.baseUrl="http://4grouppapi.eisappserver.net/";
       // this.baseUrl="http://localhost:55253/"

       this.baseUrl = 'https://opticalsapi.fadelsoft.co.in/'
   }


   CheckLogin(name,passwd) {
    return this.http.get(this.baseUrl + "api/Admin/VerifyUserLogin?LoginName=" + name + "&Password=" + passwd)
  }

  GetStoredata(usrid,storeid) {
    return this.http.get(this.baseUrl + "api/Admin/FillStore?LoginId=" + usrid + "&StoreId=" + storeid)
  }


  Getuserdata(usrid,storeid) {
    return this.http.get(this.baseUrl + "api/Admin/GetUsers?LoginId=" + usrid + "&StoreId=" + storeid)
  }

  Getsalesmamndata(usrid,storeid) {
    return this.http.get(this.baseUrl + "api/Admin/GetSalesMan?LoginId=" + usrid + "&StoreId=" + storeid)
  }


  GetCategoriesdata() {
    return this.http.get(this.baseUrl + "api/Admin/FillCategory")
  }

  Getperscriptiondata() {
    return this.http.get(this.baseUrl + "api/Admin/GetPrescriptionDropDowns")
  }

  GetBranddata(name) {
    return this.http.get(this.baseUrl + "api/Admin/GetBrand?BrandName=" + name)
  }

  Getproductdata(catid,brndid,storeid,name) {
    return this.http.get(this.baseUrl + "api/Admin/GetProduct?CategoryId=" + catid+ "&BrandId=" + brndid +"&StoreId=" + storeid +"&ProductName=" + name)
  }

  Getsalesgriddata(id) {
    return this.http.get(this.baseUrl + "api/Admin/GetSalesDetailsGrid?SalesId=" + id)
  }

  Deletesaledata(id,loginid) {
    return this.http.get(this.baseUrl + "api/Admin/DeleteSales?SaleId=" + id+"&LoginId=" + loginid)
  }
  

  Getsalesinvoicedata(id) {
    return this.http.get(this.baseUrl + "api/Admin/GetInvoiceDetails?SalesId=" + id)
  }

  SavesalesCustomer(object) {
    return this.http.post(this.baseUrl + "api/Admin/InsertSales", object )
  }


  Saveorderlense(object) {
    return this.http.post(this.baseUrl + "api/Admin/SaveOrderLense", object )
  }


  SaveSalesdeatils(object) {
    debugger
    return this.http.post(this.baseUrl + "api/Admin/SaveSalesDetails", object )
  }

  Getorderlensedata(id) {
    return this.http.get(this.baseUrl + "api/Admin/GetOrderLense?SalesId=" + id)
  }


  Getqntydata(id) {
    return this.http.get(this.baseUrl + "api/Admin/GetQuantity?ProductId=" + id)
  }


  Getsaleslist(obj) {
    return this.http.post(this.baseUrl + "api/Admin/GetSalesGrid",obj)
  }


  signIn(credentials: ISignInCredentials): Observable<auth.UserCredential> {
    return from(this.afAuth.auth.signInWithEmailAndPassword(credentials.email, credentials.password));
  }

  signOut() {
    return from(this.afAuth.auth.signOut());
  }

  register(credentials: ICreateCredentials) {
    return from(
      this.afAuth.auth.createUserWithEmailAndPassword(credentials.email, credentials.password).then(
        () => {
          this.afAuth.auth.currentUser.updateProfile({ displayName: credentials.displayName });
          this.afAuth.auth.updateCurrentUser(this.afAuth.auth.currentUser);
        }
      )
    );
  }

  sendPasswordEmail(email) {
    return from(this.afAuth.auth.sendPasswordResetEmail(email));
  }

  resetPassword(credentials: IPasswordReset) {
    return from(this.afAuth.auth.confirmPasswordReset(credentials.code, credentials.newPassword));
  }

  get user(): firebase.User {
    return this.afAuth.auth.currentUser;
  }

}
